import { render, staticRenderFns } from "./AppUsers.vue?vue&type=template&id=56390cd2&scoped=true&"
import script from "./AppUsers.vue?vue&type=script&lang=js&"
export * from "./AppUsers.vue?vue&type=script&lang=js&"
import style0 from "./AppUsers.vue?vue&type=style&index=0&id=56390cd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56390cd2",
  null
  
)

export default component.exports